import React, { useMemo } from "react";
import { Image, ImageSourcePropType, Platform } from "react-native";
import {
  AHIcon,
  AHText,
  Box,
  Circle,
  ColorType,
  TouchableBox,
  useLayoutContext,
} from "arkh";
import * as Haptics from "expo-haptics";

export const RoutineControlTypeOption = (props: {
  title: string;
  source: ImageSourcePropType;
  selected: boolean;
  warn?: boolean;
  onPress(): void;
}) => {
  const layout = useLayoutContext();

  const tint = useMemo(
    () =>
      props.selected ? (props.warn ? "negative" : "primary") : "border-strong",
    [props.selected, props.warn]
  );

  const checkColor: ColorType = useMemo(
    () =>
      props.selected
        ? props.warn
          ? "negative"
          : "primary"
        : "surface-backgroundControl",
    [props.selected, props.warn]
  );

  const size = 60;
  const borderWidth = props.selected ? 2 : 1;

  return (
    <TouchableBox
      onPressIn={() => {
        if (Platform.OS === "ios") {
          Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        }
      }}
      hitSlop={{ left: 22, right: 22, top: 30, bottom: 15 }}
      style={{ alignItems: "center" }}
      onPress={props.onPress}
      disabled={props.selected}
    >
      <Box
        borderColor={tint}
        style={{
          margin: -borderWidth,
          borderWidth,
          overflow: "hidden",
        }}
        cornerRadius="medium"
      >
        <Box
          style={{
            width: size + layout.space.small * 2,
            height: size + layout.space.small * 2,
            overflow: "hidden",
          }}
          color="surface-backgroundControl"
          spaceHorizontal="small"
          spaceVertical="small"
        >
          <Image
            source={props.source}
            style={{ height: size, width: size }}
            resizeMode="contain"
          />
        </Box>
      </Box>
      <AHText
        type="detail"
        color="text-primary"
        spaceTop="xsmall"
        spaceBottom="small"
      >
        {props.title}
      </AHText>
      <Circle
        size="smallMedium"
        color={checkColor}
        borderColor={tint}
        style={{ borderWidth: 1 }}
      >
        {props.selected ? (
          <AHIcon type="check" color="text-inverted" size="small" />
        ) : null}
      </Circle>
    </TouchableBox>
  );
};
